export const getAttentionText = state => state.commonTextsReducer.attention
export const getErrorText = state => state.commonTextsReducer.error
export const getWarningText = state => state.commonTextsReducer.warning
export const getExternalLinkText = state => state.commonTextsReducer.externalLink
export const getErrorLoginUserText = state => state.commonTextsReducer.errorLoginUser



// WEBPACK FOOTER //
// ./src/features/CommonTexts/data/selectors.js